import MasterCrud from "@/components/app/MasterCrud";
export default function Locations() {
  return (
    <MasterCrud endpoint="/production-locations" title="Lokasi Produksi"
      fields={[
        { key: "code", label: "Kode", type: "text", required: true },
        { key: "name", label: "Nama Lokasi", type: "text", required: true },
        { key: "address", label: "Alamat", type: "textarea" },
      ]}
    />
  );
}
